import { createEnv } from "@pushup/shared";
import { z } from "zod";

const schema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default("/api"),
  /** Cloudflare Turnstile widget site key for the sign-in screen. */
  VITE_TURNSTILE_SITE_KEY: z
    .string()
    .optional()
    .transform((v) => (v?.length ? v : undefined)),
});

/** Validated Vite environment variables (VITE_* only). */
export const env = createEnv(schema, import.meta.env);
